import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import {
  signalBorders,
  signalRadii,
  signalShadows,
  signalSurfaces,
} from '@/theme/foundations/tokens';

interface GlassCardProps {
  children?: React.ReactNode;
  width?: number | string;
  padding?: string;
  sx?: SxProps<Theme>;
}

/**
 * The floating panel the design uses for anything that sits *over* the app —
 * the upload steps, the sign-in card, the share dialog. Blurred translucent
 * fill plus a one-pixel top highlight, which is what sells it as glass rather
 * than as a flat card.
 */
export const GlassCard: React.FC<GlassCardProps> = ({
  children,
  width = 640,
  padding = '30px',
  sx,
}) => (
  <Box
    sx={{
      width,
      maxWidth: '100%',
      padding,
      borderRadius: `${signalRadii['3xl']}px`,
      border: `1px solid ${signalBorders.stronger}`,
      background: signalSurfaces.glass,
      backdropFilter: 'blur(24px)',
      boxShadow: signalShadows.modal,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default GlassCard;
